import { ISSUE_RESOLVED } from "./mapping";

export const NAILED_IT = "Nailed it";
export const CANT_DECIDE = "Can't decide";
export const NOT_REALLY = "Not really";

export const EMAIL = "E";
export const CALL = "C";
export const SOCIAL = "S";
export const WHATSAPP = "W";

export const choicesSecondQuestion = {
  [NAILED_IT]:
    "That's really great to hear! Are there any areas that particularly impressed you or things we could improve on?",
  [CANT_DECIDE]:
    "Thanks for the feedback. Do you have any suggestions on how we can improve?",
  [NOT_REALLY]:
    "Sorry to hear that, please let us know what you think we could we be doing better?",
};

export const choicesThirdQuestion = {
  [NAILED_IT]:
    "Are you happy for us to use your comments for marketing purposes?",
  [CANT_DECIDE]: `${ISSUE_RESOLVED} *`,
  [NOT_REALLY]: `${ISSUE_RESOLVED} *`,
};

export const YES = "Yes";
// eslint-disable-next-line id-length
export const NO = "No";
